import {Link, NavLinkRenderProps} from 'react-router'
import {SupportedLanguage} from '~/utils/locales'
import {WebsitePath} from '~/utils/routes'
import {AppPath} from '~/utils/routes.app'
import {SupportPath} from '~/utils/routes.support'

type CommonLinkProps = Omit<React.ComponentProps<typeof Link>, 'to' | 'relative' | 'className'>

type BaseTWebsiteLinkProps = {
  to: WebsitePath
  queryParams?: Record<string, string>
  customLocale?: SupportedLanguage
  noRedirect?: boolean
}
type NavTLinkProps = BaseTWebsiteLinkProps & {
  isNav: true
  className?: string | ((props: NavLinkRenderProps) => string | undefined) | undefined
}
type RegularTWebsiteLinkProps = BaseTWebsiteLinkProps & {
  isNav?: false
  className?: string
}
export type TWebsiteLinkProps = CommonLinkProps & (NavTLinkProps | RegularTWebsiteLinkProps)

export type TAppLinkProps = CommonLinkProps & {
  to: AppPath
  queryParams?: Record<string, string>
  customLocale?: SupportedLanguage
  className?: string
}

export type TSupportLinkProps = CommonLinkProps & {
  to: SupportPath | undefined
  className?: string
}

type BuildParamsOptions = {
  queryParams?: Record<string, string>
  isAppUrl?: boolean
  locale?: SupportedLanguage
  noRedirect?: boolean
}

export const buildSearchParams = ({
  queryParams = {},
  isAppUrl,
  locale,
  noRedirect
}: BuildParamsOptions) => {
  const params: Record<string, string> = {...queryParams}

  if (isAppUrl && locale) {
    params.lng = locale
  } else if (noRedirect) {
    params.noRedirect = 'true'
  }

  const hasParams = Object.keys(params).length > 0
  if (!hasParams) return {searchParams: null, searchString: ''}

  return {searchParams: params, searchString: `?${new URLSearchParams(params).toString()}`}
}
